import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import {
  DisplayColumnDashboard,
  DisplayColumnKey,
  DisplayColumnSettings,
} from '@/models/features/display-column.models'

export type GetDisplayColumnRequest = {
  buildingId: number | undefined
  dashboard: DisplayColumnDashboard
  column: DisplayColumnKey
}

export const getDisplayColumnQueryKey = (data: GetDisplayColumnRequest) =>
  ['useGetDisplayColumn', data] as const

const getDisplayColumn = async (data: GetDisplayColumnRequest, signal?: AbortSignal) => {
  const response = await authAPI.get<DisplayColumnSettings>('/display-column', {
    params: data,
    signal,
  })
  return response.data
}

export const useGetDisplayColumn = (
  data: GetDisplayColumnRequest,
  { enabled = true }: { enabled?: boolean } = {},
) =>
  useQuery({
    enabled: enabled && !!data.buildingId,
    queryFn: ({ signal }) => getDisplayColumn(data, signal),
    // Note: no staleTime override - the settings are shared per building and can change elsewhere
    // (another manager, the BE), so every visit reloads them like the rest of the app's data.
    queryKey: getDisplayColumnQueryKey(data),
  })
